module.exports = __webpack_public_path__ + "img/googleIcon.72ab1d91.svg";